import React from "react";

export const SectionCard = ({ name, data }: any) => {
    const total = data?.total_voters || 0;

    const voted = Object.values(data?.gotv_party || {}).reduce((a: number, b: any) => a + Number(b), 0);

    const notVoted = total - voted;

    const partyData = data?.gotv_party;

    const hasPartyData = partyData && Object.keys(partyData).length > 0;

    return (
        <div className="rounded-2xl border bg-white p-4 shadow-sm transition hover:shadow-md">
            <div className="mb-3">
                <div className="text-xs text-gray-400">Street</div>

                <div className="truncate text-sm font-semibold text-gray-800" title={name}>
                    {name}
                </div>
            </div>

            <div className="grid grid-cols-3 text-center text-sm">
                <div>
                    <div className="text-gray-400">Total</div>
                    <div className="font-bold">{total}</div>
                </div>

                <div>
                    <div className="text-green-600">Polled</div>
                    <div className="font-bold text-green-600">{voted}</div>
                </div>

                <div>
                    <div className="text-red-500">Not Voted</div>
                    <div className="font-bold text-red-500">{notVoted}</div>
                </div>
            </div>

            {hasPartyData && (
                <div className="mt-3 space-y-1 text-xs text-gray-600">
                    {Object.entries(partyData).map(([party, val]: any) => (
                        <div key={party} className="flex justify-between">
                            <span>{party}</span>
                            <span>{val}</span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};
